import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Professional.css';
import './pages.css';
import projectDescriptions from '../data/projectDescriptions';
import CircleParticles from '../components/effects/CircleParticles';
import SleepingBear from '../components/effects/SleepingBear';
import MobileNotice from '../components/effects/MobileNotice';
// Import the images from the assets folder
// import faireImage from '../assets/faire.png';
// import jjImage from '../assets/j&j.png';
// import awsImage from '../assets/CloudClub.png';
// import cfpImage from '../assets/poker.png';
// import raytracerImage from '../assets/rayTracer.png';
// import compilerImage from '../assets/compiler.png';
// import octoImage from '../assets/octoprotect.png';
// import soonImage from '../assets/soon.png'; // Import the soon.png image
// import astro from '../assets/astro.png';

// Import hackathon images
// import techImage from '../assets/tech.png';
// import mitImage from '../assets/mit.png';
// import sheImage from '../assets/she.png';
// import htnImage from '../assets/htn.png'; // Updated to new image file
// import web3Image from '../assets/web3.png';
// import hawkImage from '../assets/hawk.png';

// Import conference images
// import susqImage from '../assets/sig.png';
// import citadelImage from '../assets/boundless.png';
// import janeStreetImage from '../assets/wise.png';
// import graceHopperImage from '../assets/grace.png';
// import wecodeImage from '../assets/harvard.png';
// import openaiImage from '../assets/openai.png';

const Professional = () => {
  // Remove carousel-related state and refs
  // const [showHackathonSet, setShowHackathonSet] = useState(1);
  // const hackathonsSectionRef = useRef(null);
  // const hawkHacksRef = useRef(null);
  
  // Keep popup state
  const [popupActive, setPopupActive] = useState(false);
  const [popupContent, setPopupContent] = useState({
    title: '',
    subtitle: '',
    description: '',
    image: ''
  });

  // Remove carousel-related functions
  // const toggleHackathonSet = () => { ... }

  // Remove carousel-related useEffect
  // useEffect(() => { ... }, []);

  // Update openPopup function
  const openPopup = (item) => {
    // Store current scroll position
    const scrollY = window.scrollY;
    
    setPopupContent({
      title: item.title,
      subtitle: item.subtitle || '',
      description: getDescription(item.title),
      image: item.hidePopupImage ? '' : item.image
    });
    setPopupActive(true);
    
    // Prevent body scrolling when popup is open and maintain scrollbar space
    document.body.style.top = `-${scrollY}px`;
    document.body.classList.add('popup-open');
  };

  // Function to get description from the imported file
  const getDescription = (title) => {
    return projectDescriptions[title] || 
      `Got flown out to New York with some really inspiring students for these 3 programs.\n
      Insight - OCaml bootcamp\n
      WiSE + WiSE Reunion - Leaning probabilities, market making, and liquidity provision
      `;
  };

  // Function to close popup
  const closePopup = () => {
    setPopupActive(false);
    
    // Restore scroll position
    const scrollY = document.body.style.top;
    document.body.classList.remove('popup-open');
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  };

  // Close popup when clicking outside of it
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('popup-overlay')) {
      closePopup();
    }
  };

  // Close popup when pressing Escape key
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && popupActive) {
        closePopup();
      }
    };

    window.addEventListener('keydown', handleEscKey);
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [popupActive]);

  const sections = {
    internships: [
      {
        title: "Notion - Infra Backend Intern",
        description: "Distributed data model inspired by TAO",
        image: "/images/notion.svg"
      },
      {
        title: "Rundoo - Software Engineering Intern",
        description: "ACH Payment System, Dynamic Report Builder, Notification Systems",
        image: "/images/rundoo1.png"
      },
      {
        title: "Faire - Software Engineering Intern",
        description: "Recommendation System Feature, Latency Reductions, Impression/Context Providers, SDUI",
        image: "/images/faire.png"
      },
      {
        title: "Johnson & Johnson - Data + Backend",
        description: "Backend for Snowflake data updating app, Recon frameworks for data ingestion, ML",
        image: "/images/j&j.png"
      },
      {
        title: "Hack the North - Sponsorships Team",
        description: "Sponsorships, VC involvement",
        image: "/images/htn-sponsorships.svg"
      },
      {
        title: "Coming Soon...",
        description: "Stay tuned",
        image: "/images/astro.webp",
        astronaut: true,
        hidePopupImage: true // popup is just the Spotify embed
      }
    ],
    projects: [
      {
        title: "AWS Cloud Club Founder",
        description: "400+ members, AWS Sponsored",
        image: "/images/CloudClub.png"
      },
      {
        title: "MCP Marketplace Integration",
        description: "Poke + Custom MCP",
        image: "/images/mijiji.png"
      },
      {
        title: "Linguini",
        description: "Inspired by Worldle, full database logic",
        image: "/images/linguini1..png"
      },
      {
        title: "Compiler",
        description: "Scala - convert text to assembly",
        image: "/images/compiler.png"
      },
      {
        title: "Octoproject",
        description: "Bluetooth security for belongings",
        image: "/images/octoprotect.png"
      },
      {
        title: "Mural",
        description: "Painting",
        image: "/images/mural.jpg"
      }
    ],
    hackathons: [
      {
        title: "Technova (WINNER)",
        description: "Gamified stock investments",
        image: "/images/tech.png"
      },
      {
        title: "HackMIT",
        description: "Mood adaptive VR environment",
        image: "/images/mit.png"
      },
      {
        title: "SheHacks (WINNER)",
        description: "Squid Games for studying",
        image: "/images/she.png"
      },
      {
        title: "Hack the North",
        description: "Home security discord bot",
        image: "/images/htn.png"
      },
      {
        title: "Web3Apps (WINNER)",
        description: "Social media...redefined",
        image: "/images/web3.png"
      },
      {
        title: "HawkHacks",
        description: "Computer vision water intake tracker",
        image: "/images/hawk.png"
      }
    ],
    conferences: [
      {
        title: "Jane Street (x3) - Insight (SWE Track), WiSE, WiSE Reunion",
        image: "/images/wise.png"
      },
      {
        title: "Citadel Boundless",
        image: "/images/boundless.webp"
      },
      {
        title: "Susquehanna Discovery",
        image: "/images/sig.png"
      },
      {
        title: "Grace Hopper",
        image: "/images/grace.png"
      },
      {
        title: "Harvard WeCode",
        image: "/images/harvard.webp"
      },
      {
        title: "OpenAI Leadership Exchange",
        image: "/images/openai.png"
      }
    ]
  };

  return (
    <div className="professional">
      <MobileNotice />
      <div className="sections-container">
        {Object.entries(sections).map(([sectionName, items], index) => {
          // Remove special handling for hackathons2
          return (
            <section 
              key={sectionName} 
              className={`section ${sectionName}-section`}
              // Remove ref for hackathons section
            >
              <div className="section-header">
                <h2>{sectionName.charAt(0).toUpperCase() + sectionName.slice(1)}</h2>
                {sectionName === 'internships' && <SleepingBear />}
              </div>
              <div className="items-grid">
                {items.map((item, itemIndex) => (
                  item.placeholder ? (
                    <div key={itemIndex} className="item placeholder-item" data-title={item.title}>
                      <div className="placeholder-box">✦</div>
                      <div className="item-content">
                        <h3>{item.title}</h3>
                        {item.description && <p>{item.description}</p>}
                      </div>
                    </div>
                  ) : (
                  <div
                    key={itemIndex}
                    className={`item${item.astronaut ? ' astronaut-item' : ''}`}
                    data-title={item.title}
                    style={{cursor: 'pointer'}}
                    onClick={() => openPopup(item)}
                  >
                    {item.astronaut && <CircleParticles />}
                    {item.image ? (
                      <div className="company-image-container">
                        <img
                          src={item.image}
                          alt={item.title}
                          className="company-image"
                        />
                      </div>
                    ) : (
                      <div className="placeholder-box"></div>
                    )}
                    <div className="item-content">
                      <h3>{item.title}</h3>
                      {item.subtitle && <h4>{item.subtitle}</h4>}
                      <p>{item.description}</p>
                    </div>
                  </div>
                  )
                ))}
              </div>
            </section>
          );
        })}
      </div>
      
      {/* Popup overlay — rendered in a portal so it escapes the
          route-container stacking context and sits above the fixed header */}
      {createPortal(
      <div
        className={`popup-overlay ${popupActive ? 'active' : ''}`}
        onClick={handleOverlayClick}
      >
        <div className="popup-content">
          <button className="popup-close" onClick={closePopup}>×</button>
          <div className="popup-header">
            <h2 className="popup-title">{popupContent.title}</h2>
            {popupContent.subtitle && <h3 className="popup-subtitle">{popupContent.subtitle}</h3>}
          </div>
          <div className="popup-body">
            {popupContent.image && (
              <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                <img 
                  src={popupContent.image} 
                  alt={popupContent.title}
                  className="popup-image"
                  style={{ 
                    width: '100%', 
                    height: '300px', 
                    objectFit: 'cover',
                    borderRadius: '8px',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                  }}
                />
              </div>
            )}
            <div
              className="popup-description"
              dangerouslySetInnerHTML={{ __html: popupContent.description }}
              style={{ lineHeight: 1.6 }}
            />
          </div>
        </div>
      </div>,
      document.body
      )}
    </div>
  );
};

export default Professional; 